import { Circle } from 'react-leaflet';
import WeatherMapDetailsPopup from '../../../../../../components/WeatherMapDetailsPopup/WeatherMapDetailsPopup';
import {
  earthquakeDetailGroups,
  earthquakeDetails,
} from '../../../../config/earthquakeDetails.config';
import {
  EARTHQUAKES_PATH_OPTIONS,
  EARTHQUAKES_SELECTED_PATH_OPTIONS,
} from '../../../../config/earthquakes.config';
import {
  formatEarthquakeLocation,
  getEarthquakeRadiusMeters,
} from '../../../../utils/earthquakes.utils';

const EarthquakeMapLayers = ({
  earthquakes = [],
  selectedEarthquakeId = null,
  onSelectEarthquake,
}) =>
  earthquakes.map((earthquake) => {
    const isSelected = earthquake.id === selectedEarthquakeId;
    const location = formatEarthquakeLocation(earthquake.city);

    return (
      <Circle
        key={earthquake.id}
        center={earthquake.position}
        radius={getEarthquakeRadiusMeters(earthquake.magnitude)}
        pathOptions={isSelected ? EARTHQUAKES_SELECTED_PATH_OPTIONS : EARTHQUAKES_PATH_OPTIONS}
        eventHandlers={{
          click: () => onSelectEarthquake?.(earthquake),
        }}
      >
        <WeatherMapDetailsPopup
          eyebrow="Recent earthquake"
          title={location}
          selectedItem={earthquake}
          details={earthquakeDetails}
          layoutGroups={earthquakeDetailGroups}
          ariaLabel={`Details for ${location}`}
        />
      </Circle>
    );
  });

export default EarthquakeMapLayers;
